(() => {
  let uiStrings = {};
  try { uiStrings = JSON.parse(document.getElementById('TechingUiStrings')?.textContent || '{}'); } catch {}
  const uiText = (key, fallback, values = {}) => String(uiStrings[key] || fallback).replace(/\{(\w+)\}/g, (match, name) => Object.prototype.hasOwnProperty.call(values, name) ? String(values[name]) : match);
  const uiLevel = value => uiText(`level${value}`, value || '');
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-collection-section]').forEach((root) => {
      if (root.dataset.collectionReady) return;
      root.dataset.collectionReady = 'true';
      const control = root.querySelector('[data-build-level-control]');
      const select = root.querySelector('[data-build-level]');
      const grid = root.querySelector('[data-collection-grid]');
      if (!control || !select || !grid) return;
      const metadata = root.querySelector('[data-collection-pages]');
      const pageCount = Math.max(1, Number(metadata.dataset.collectionPages) || 1);
      const currentPage = Math.max(1, Number(metadata.dataset.collectionPage) || 1);
      const total = Number(metadata.dataset.collectionTotal) || 0;
      const count = root.querySelector('[data-collection-count]');
      const status = root.querySelector('[data-build-level-status]');
      const empty = root.querySelector('[data-build-level-empty]');
      const pagination = root.querySelector('.native-pagination');
      const field = root.querySelector('[data-build-level-field]');
      const originalCards = [...grid.children];
      const pages = new Map([[currentPage, originalCards]]);
      let loadPromise = null;
      let sequence = 0;
      let acceptedLevel = 'all';
      control.hidden = false;
      const allCards = async () => {
        if (pages.size === pageCount) return [...pages].sort((a, b) => a[0] - b[0]).flatMap(([, cards]) => cards);
        if (!loadPromise) loadPromise = (async () => {
          const remaining = Array.from({length: pageCount}, (_, i) => i + 1).filter((page) => !pages.has(page));
          const worker = async () => {
            while (remaining.length) {
              const page = remaining.shift();
              const url = new URL(location.href);
              url.searchParams.set('section_id', root.dataset.collectionSection);
              url.searchParams.set('page', page);
              url.searchParams.delete('build_level');
              const response = await fetch(url, {headers: {'X-Requested-With': 'XMLHttpRequest'}});
              if (!response.ok) throw new Error('Unable to load collection');
              const documentPage = new DOMParser().parseFromString(await response.text(), 'text/html');
              const otherRoot = [...documentPage.querySelectorAll('[data-collection-section]')].find((node) => node.dataset.collectionSection === root.dataset.collectionSection);
              const otherGrid = otherRoot?.querySelector('[data-collection-grid]');
              if (!otherGrid) throw new Error('Missing collection products');
              pages.set(page, [...otherGrid.children]);
            }
          };
          const results = await Promise.allSettled(Array.from({length: Math.min(4, remaining.length)}, worker));
          if (results.some((result) => result.status === 'rejected')) throw new Error('Unable to load all collection pages');
        })().finally(() => {loadPromise = null;});
        await loadPromise;
        return [...pages].sort((a, b) => a[0] - b[0]).flatMap(([, cards]) => cards);
      };
      const apply = async () => {
        const level = select.value;
        const request = ++sequence;
        status.textContent = level !== 'all' && pages.size < pageCount ? uiText("collectionLoading", "Loading all models…") : '';
        grid.setAttribute('aria-busy', 'true');
        try {
          const cards = level === 'all' ? originalCards : (await allCards()).filter((card) => card.dataset.buildLevel === level);
          if (request !== sequence) return;
          grid.replaceChildren(...cards);
          empty.hidden = cards.length > 0 || level === 'all';
          if (pagination) pagination.hidden = level !== 'all';
          count.textContent = uiText((level === 'all' ? total : cards.length) === 1 ? 'modelCountOne' : 'modelCountMany', (level === 'all' ? total : cards.length) === 1 ? '{count} model' : '{count} models', {count: level === 'all' ? total : cards.length});
          field.disabled = level === 'all';
          field.value = level;
          const url = new URL(location.href);
          if (level === 'all') url.searchParams.delete('build_level'); else url.searchParams.set('build_level', level);
          history.replaceState(history.state, '', url);
          acceptedLevel = level;
          status.textContent = '';
          document.dispatchEvent(new CustomEvent('teching:cards-updated'));
        } catch {
          if (request !== sequence) return;
          select.value = acceptedLevel;
          status.textContent = uiText("collectionError", "Unable to load all models. Please try again.");
        } finally {
          if (request === sequence) grid.removeAttribute('aria-busy');
        }
      };
      select.addEventListener('change', apply);
      root.querySelector('[data-build-level-reset]')?.addEventListener('click', () => {select.value = 'all'; apply();});
      const initialLevel = new URL(location.href).searchParams.get('build_level');
      if ([...select.options].some((option) => option.value === initialLevel)) {select.value = initialLevel; apply();}
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize()); else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
